import React from 'react';

function RedBanner({ text }) {
  return <div className="redBanner fullWidthBanner">{text}</div>;
}

export default RedBanner;
